var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.998 7.98h2.86V5.12a2.86 2.86 0 1 0-2.86 2.86Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.863 5.121a2.86 2.86 0 1 0-5.72 0v2.864h2.86a2.86 2.86 0 0 0 2.86-2.86Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.417 27.425A4.575 4.575 0 0 0 7.992 32h6.577a.286.286 0 0 0 .286-.286V18.56a.286.286 0 0 0-.286-.286H3.99a.572.572 0 0 0-.572.572Z",
    fill: "#333",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.856 15.701V7.98h2.288v7.721a.286.286 0 0 0 .286.286h10.008a3.431 3.431 0 0 0 3.432-3.432v-1.144a3.432 3.432 0 0 0-3.432-3.432h-2.9a.143.143 0 0 1-.122-.215 5.148 5.148 0 0 0-8.418-5.874 5.148 5.148 0 0 0-8.417 5.875.143.143 0 0 1-.122.215h-2.9a3.432 3.432 0 0 0-3.432 3.432v1.143a3.431 3.431 0 0 0 3.434 3.43H14.57a.286.286 0 0 0 .286-.286Zm2.288-10.58a2.86 2.86 0 1 1 2.86 2.86h-2.86Zm-5.353-2.852a2.86 2.86 0 0 1 3.064 2.852v2.864h-2.857a2.86 2.86 0 0 1-.2-5.711Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.429 32h6.577a4.575 4.575 0 0 0 4.575-4.575v-8.578a.572.572 0 0 0-.572-.572h-10.58a.286.286 0 0 0-.286.286v13.154a.286.286 0 0 0 .286.286Z",
    fill: "#333",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.9ed1c005a98fe2390d5af77e4e1f17bc.svg";
export { ForwardRef as ReactComponent };